// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Aziende_buttonContainer__Uun5q","title":"Aziende_title__6SWm0","loadingRow":"Aziende_loadingRow__YZs4E","box":"Aziende_box__MJlsn"};